import { filter, isEmpty, sumBy } from 'lodash';
import { Record } from 'immutable';
import * as PurchaseMethods from 'commons-vehicle/PurchaseMethods/constants/purchaseMethods.js';
import PURCHASE_METHODS from 'commons-vehicle/PurchaseMethods/constants/purchaseMethodsValues.js';
import { DATA_TYPES } from 'commons-vehicle/constants/dataTypes.js';

const CashPurchaseRecord = Record({
    purchaseMethod: PurchaseMethods.CASH_PURCHASE,
    purchaseMethodValue: PURCHASE_METHODS.CASH,
    selected: false,
    available: true,
    retail: 0,
    retailAdjustment: 0,
    discounts: 0,
    rebates: 0,
    rebatesTaxes: 0,
    rebatesAtDelivery: 0,
    pricingAmounts: {
        msrp: 0,
        freightPDI: 0,
        taxesAndDuties: 0,
    },
    dealerFees: 0,
    optionsAdjustment: 0,
    optionsTaxesAdjustment: 0,
    netTradeInAdjustment: 0,
    tradeInTaxesAdjustment: 0,
    includedItemsCodes: [],
    rebatesDetails: [],
    optionsAdjustmentDiscounts: 0,
});

class CashPurchase extends CashPurchaseRecord {
    getRetail() {
        return this.retail + this.optionsAdjustment;
    }

    getTotalRebates() {
        return this.discounts + this.rebates + this.optionsAdjustmentDiscounts;
    }

    getTotalRebatesWithTaxes() {
        return this.discounts + this.rebates + this.rebatesTaxes + this.optionsAdjustmentDiscounts;
    }

    getElectricRebate() {
        const electricRebates = filter(this.rebatesDetails, (rebateDetails) => {
            return rebateDetails.typeId === DATA_TYPES.REBATE.TYPES.ELECTRIC;
        });

        if (isEmpty(electricRebates)) {
            return null;
        }

        return {
            description: electricRebates[0].description,
            taxes: sumBy(electricRebates, (electricRebate) => electricRebate.taxes),
            rebate: sumBy(electricRebates, (electricRebate) => electricRebate.amount),
        };
    }

    getEmployeeRebate() {
        const employeeRebates = filter(
            this.rebatesDetails,
            (rebateDetails) => rebateDetails.typeId === DATA_TYPES.REBATE.TYPES.EMPLOYEE
        );

        if (isEmpty(employeeRebates)) {
            return null;
        }

        return {
            description: employeeRebates[0].description,
            rebate: sumBy(employeeRebates, (employeeRebate) => employeeRebate.amount),
        };
    }
}

export default CashPurchase;
